import { Component } from "react"
import { View, Text, TouchableOpacity, StyleSheet } from "react-native"

// Catches any render-time throw in the app tree and shows a calm, actionable
// fallback instead of an unmounted white page. For a payment surface the copy
// is deliberately neutral about money: it neither claims success nor failure,
// and points the payer at their receipt / support / reload.
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error) {
        // IDs/outcomes only — never request bodies or PII.
        console.error("billing.bh render error", error && error.message)
    }

    reload = () => {
        this.setState({ hasError: false })
        if (typeof window !== "undefined" && window.location) {
            window.location.reload()
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <View style={styles.outer}>
                    <View style={styles.card}>
                        <Text style={styles.title}>Something went wrong</Text>
                        <Text style={styles.message}>
                            We couldn’t display this page. If you were paying and aren’t sure it went through, check your email for a receipt, or contact help@consultmebh.com.
                        </Text>
                        <TouchableOpacity onPress={this.reload} style={styles.action} activeOpacity={0.85} accessibilityRole="button" accessibilityLabel="Reload page">
                            <Text style={styles.actionText}>Reload page</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            )
        }
        return this.props.children
    }
}

const styles = StyleSheet.create({
    outer: {
        flex: 1,
        backgroundColor: '#f5f6f8',
        alignItems: 'center',
        justifyContent: 'center'
    },
    card: {
        backgroundColor: 'white',
        padding: 28,
        marginHorizontal: 16,
        borderWidth: 1,
        borderColor: '#e6e8ec',
        borderRadius: 18,
        maxWidth: 380,
        width: '90%',
        alignItems: 'center',
        shadowColor: '#101828',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.06,
        shadowRadius: 16,
        elevation: 3
    },
    title: {
        fontSize: 17,
        fontWeight: '600',
        color: '#1f2430',
        textAlign: 'center'
    },
    message: {
        marginTop: 10,
        fontSize: 14,
        lineHeight: 21,
        color: '#6b7280',
        textAlign: 'center'
    },
    action: {
        marginTop: 18,
        paddingVertical: 12,
        paddingHorizontal: 22,
        borderRadius: 14,
        backgroundColor: 'rgb(0, 54, 246)'
    },
    actionText: {
        color: 'white',
        fontSize: 14,
        fontWeight: '600'
    }
})
